export enum DncCheckMode {
  INSTANT = "INSTANT",
  DELAYED = "DELAYED",
}
